const MIN_LINE_HEIGHT = 0.8;
const normalizeLineHeight = (lineHeight) => {
  let unit = "";
  if (typeof lineHeight === "string" && lineHeight.match(/^\d+(\.\d+)?$/) || typeof lineHeight === "number") {
    unit = "em";
  }
  return `max(${MIN_LINE_HEIGHT}em, ${lineHeight}${unit})`;
};
export {
  MIN_LINE_HEIGHT,
  normalizeLineHeight
};
//# sourceMappingURL=line-spacing-utils.js.map
